import {Component, OnInit, OnDestroy, Input, Output, EventEmitter} from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import {AppToastrService, RoutingService, ClientsService, StorageService} from 'app/services';
import {Discount, Member} from 'app/models';



@Component({
  selector: 'app-client-details',
  templateUrl: './client-details.html',
  styleUrls: ['./client-details.scss']
})

export class ClientDetailsComponent implements OnInit, OnDestroy {

  @Input() client: any;
  // @Input() clientId: any;
  @Output() notify: EventEmitter<any> = new EventEmitter<any>();

  contact: any;
  showEditClient: boolean;
  showPasswordPopup: boolean;
  confirm: any;
  pageTitle: any;
  member: any;
  discount: {
    data: Discount,
    index: number
  };

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: [ '<span class="lnr lnr-chevron-left"></span>', '<span class="lnr lnr-chevron-right"></span>' ],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 2
      },
      740: {
        items: 3
      },
      940: {
        items: 4
      }
    },
    nav: true
  }


  constructor(private routingService: RoutingService,
              private clientsService: ClientsService,
              private toast: AppToastrService,
              private storage: StorageService) {
  }


  ngOnInit() {
    console.log(this.client);
    // console.log('!!!!this.client', this.client)
  }

  ngOnDestroy() {
  }

  onNotify(event: any) {
    this.showEditClient = false;
    this.showPasswordPopup = false;
    this.discount = null;
    this.member = null;
    if (event.type === 'createClient') {
      this.client = event.data;
    // } else if (event.type === 'createDiscount') {
    //   this.client.discounts.push(event.data);
    // } else if (event.type === 'updateDiscount') {
    //   this.client.discounts[event.index] = event.data;
    // } else if (event.type === 'deleteDiscount') {
    //   this.client.discounts.splice(event.index, 1);
    } else if (event.type === 'createMember') {
      this.client.members.push(event.data);
    } else if (event.type === 'updateMember') {
      this.client.members[event.index] = event.data;
    } else if (event.type === 'updateClient') {
      this.notify.emit({
        type: 'updateClient',
        data: event.data
      });
    }
  }

  openEditPopup(client?: Member) {
    this.showEditClient = true;
  }

  openPasswordPopup() {
    this.showPasswordPopup = true;
  }

  openDiscountPopup(e?: any, discount?: any, index?: number) {
      const name = e ? e.target.className : '';
      if (!name || name.indexOf('lnr ') === -1) {
        this.discount = {data: discount, index};
      }
  }

  // deleteDiscount(discount: Discount, index: number) {
  //   this.confirm = {
  //     action: 'Удаление',
  //     message: `Вы уверены, что хотите удалить акцию?`,
  //     type: 'deleteDiscount',
  //     show: true,
  //     data: {discount, index}
  //   };
  // }
  //
  // private _deleteDiscount(discount: Discount, index: number) {
  //   this.client.discounts.splice(index, 1);
  //   this.clientsService.deleteDiscount( discount.id).subscribe(() => {
  //     this.toast.showToast({title: 'Акция успешно удалена'});
  //   }, (err) => {
  //     this.toast.showToastFromError(err);
  //     this.client.discounts.splice(index, 0, discount);
  //   });
  // }

  onConfirmNotify(e) {
    this.confirm = null;
    if (e.type === 'success' && e.data.type === 'deleteMember') {
      this._deleteMember(e.data.data.member, e.data.data.index);
    // } else if (e.type === 'success' && e.data.type === 'deleteDiscount') {
    //   this._deleteDiscount(e.data.data.discount, e.data.data.index);
    }
  }

  openEditMemberPopup(member?: Member, i?: number) {
    this.member = {
      data: member,
      index: i
    };
  }

  deleteMember(member: Member, index: number) {
    this.confirm = {
      action: 'Удаление',
      message: `Вы уверены, что хотите удалить связанное лицо?`,
      type: 'deleteMember',
      show: true,
      data: {member, index}
    };
  }

  private _deleteMember(member: Member, index: number) {
    this.client.members.splice(index, 1);
    this.clientsService.deleteMember(member.id).subscribe(() => {
      this.toast.showToast({title: 'Связанное лицо успешно удалёно'});
    }, (err) => {
      this.toast.showToastFromError(err);
      this.client.members.splice(index, 0, member);
    });
  }
}
